import React from "react";
import {dangerousHtmlDiv} from "../../lib/utils";
import connect from "react-redux/es/connect/connect";
import Accordion from "react-bootstrap/Accordion";

const allHtmlEntities = require('html-entities').AllHtmlEntities;
const entities = new allHtmlEntities();

const stateMap = (store) => {
    return {
        i18n: store.i18n
    };
};

class Faq extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            topFaqAnswer: '',
            topFaqQuestion: ''
        }

        this.faqLocalizedResponse = this.faqLocalizedResponse.bind(this);
    }

    componentDidMount() {
        this.faqLocalizedResponse()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i18n.locale !== this.props.i18n.locale) {
            this.setState({
                locale: nextProps.i18n.locale
            }, () => {
                this.faqLocalizedResponse()
            })
        }
    }


    faqLocalizedResponse() {
        const isLocaleEl = this.props.i18n.locale === 'el'
        this.setState({
            topFaqAnswer: entities.decode(isLocaleEl ? this.props.topFaq.answer : this.props.topFaq.answerEn),
            topFaqQuestion: entities.decode(isLocaleEl ? this.props.topFaq.question : this.props.topFaq.questionEn)
        })
    }

    render() {
        return (
            <Accordion.Item id={"collapsible-panel-faq-" + this.props.topFaq.faqId}
                            className="faq__element"
                            eventKey={this.props.evtKey}>
                <Accordion.Header>
                    <div className="faq__title">
                        {this.state.topFaqQuestion}
                    </div>
                    <i className="icon-plus-accordion"></i>
                    <i className="icon-minus-accordion"></i>
                </Accordion.Header>
                <Accordion.Body>
                    {dangerousHtmlDiv(this.state.topFaqAnswer)}
                </Accordion.Body>
            </Accordion.Item>
        )
    }
}

export default connect(stateMap)(Faq);
